<template>
	<div>
		<modalconfirm ref="modalReceiptPDO" @action="proccessPDO"/>
		<modalconfirm noconfirm ref="modalInfoPDO"/>
		<div class="text-h5">Proses Penerimaan Barang</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-form>
					<v-row>
						<v-col cols="12" md="4" sm="4">
							<v-autocomplete item-value="pdo_code" @change="getDetail(pdo_code)" hide-details v-model="pdo_code" :items="PDOforAccept" label="Kode Purchase Order" outlined dense :error-messages="responseError.pdo_id" @focus="() => responseError.pdo_id = ''" no-data-text="Tidak ada data yang sesuai" :filter="customFilter">
								<template v-slot:item = {item}>
									{{item.pdo_code}} - {{item.supplier_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.pdo_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="8" v-if="Object.keys(detailPDO).length > 0">
							<div class="font-weight-bold">Detail Supplier</div>
							<v-row>
								<v-col cols="12" md="4">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailPDO.supplier_name }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon>mdi-email</v-icon>
										<div class="pl-3">{{ detailPDO.supplier_email }}</div>
									</div>
								</v-col>
								<v-col cols="12" md="8">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailPDO.supplier_mobilephone }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addressText }}</div>
									</div>
								</v-col>
							</v-row>
							<div class="font-weight-bold">Catatan : {{ detailPDO.pdo_note ? detailPDO.pdo_note : '-' }}</div>
						</v-col>
						<v-col cols="12" class="">
							<v-data-table disable-pagination :headers="headers" :items="productPDO" hide-default-footer class="white-row" no-data-text="Belum ada data yang dapat ditampilkan">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.pdo_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.pdo_detail_product_code }}</div>
								</template>
								<template v-slot:item.quantity_sent="{ item }">
									<div class="pt-2">{{ item.pdo_detail_quantity_sent | toNumber }}</div>
								</template>
								<template v-slot:item.quantity_received="{ item }">
									<v-currency-field class="py-3" v-model="item.quantity" outlined dense hide-details="auto" background-color="white"></v-currency-field>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="!pdo_code" depressed class="text-capitalize" @click="receipt">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			pdo_code: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: false},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Dikirim', value: 'quantity_sent', sortable: false, align: 'center'},
			{ text: 'Jumlah Diterima', value: 'quantity_received', sortable: false, width: '17%'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('pdo', ['detailPDO', 'response', 'responseError', 'PDOforAccept']),
		...mapGetters('pdo', ['productPDO']),

		addressText() {
			var data = []
			if (this.detailPDO) {
				if (this.detailPDO.supplier_address)
					data.push(this.detailPDO.supplier_address)
				if (this.detailPDO.supplier_subdistrict_name)
					data.push(this.detailPDO.supplier_subdistrict_name)
				if (this.detailPDO.supplier_city_name)
					data.push(this.detailPDO.supplier_city_name)
				if (this.detailPDO.supplier_province_name)
					data.push(this.detailPDO.supplier_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('pdo', ['getDetailPDO', 'approvePO', 'receivePDO', 'getOptionPDOforAccept']),
		...mapMutations('pdo', ['setDetailPDO', 'clearDataPDO', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailPDO(code)
			} else {
				this.setDetailPDO('')
			}
		},
		receipt(){
			let msg = "Yakin akan memproses penerimaan barang?"
			this.$refs.modalReceiptPDO.setMessage(msg)
			this.$refs.modalReceiptPDO.showConfirm()
		},
		async proccessPDO() {
			await this.setOverlay(true)
			await this.$refs.modalReceiptPDO.hideConfirm()
			let product = await this.productPDO.map((el) => {
				return {
					product_id: el.pdo_detail_product_id,
					product_name: el.pdo_detail_product_name,
					quantity: el.quantity
				}
			})
			let params = await {
				pdo_id: this.detailPDO.pdo_id,
				product: product
			}
			await this.receivePDO(params).then(() => {
				if (this.response.data.completed) {
					this.$refs.modalInfoPDO.showConfirm()
					this.$refs.modalInfoPDO.setMessage('Barang yang diterima sudah sesuai dengan Pesanan Anda. Status Purchase Order transaksi ini akan berubah menjadi Selesai.')
					this.$refs.modalInfoPDO.setCloseText("OK")
				}
				if (this.response.code == 200.) {
					this.saveResponse({})
					this.pdo_code = ''
					this.setDetailPDO('')
					this.getOptionPDOforAccept()
				}
			})
			await this.setOverlay(false)
		},
		customFilter (item, queryText) {
			const textOne = item.pdo_code.toLowerCase()
			const textTwo = item.supplier_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
		},
	},
	created() {
		this.getOptionPDOforAccept()
		this.$store.dispatch('setPageTitle', `Approval Penerimaan Barang`)
		if (this.$route.params.code) {
			this.pdo_code = this.$route.params.code
			this.getDetailPDO(this.pdo_code)
		}
	},
	beforeDestroy(){
		this.clearDataPDO()
	},
	watch: {
	}
}
</script>